export default __webpack_public_path__ + "static/media/actividad-13.d81ca108.mp3";